import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const styles = require('./styles.pcss');

type Props = {
  event: any | null;
  onClose: () => void;
};

function AuditEventDetailDialog({ event, onClose }: Props) {
  return (
    <Dialog open={!!event} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle className={styles.modalTitle}>
        Event Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          className={styles.modalCloseButton}
          size="small"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      {event && (
        <DialogContent dividers>
          <table className={styles.detailTable}>
            <tbody>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>scan</td>
                <td className={styles.detailValue}>{event.scan ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>scanned</td>
                <td className={styles.detailValue}>{event.scanned ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>status</td>
                <td className={styles.detailValue}>{event.status ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>name</td>
                <td className={styles.detailValue}>{event.name ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>namespace</td>
                <td className={styles.detailValue}>{event.namespace ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>timestamp</td>
                <td className={styles.detailValue}>
                  {event.timestamp ? new Date(event.timestamp).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'UTC', timeZoneName: 'short' }) : '—'}
                </td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>userId</td>
                <td className={styles.detailValue}>{event.userId ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>organizationId</td>
                <td className={styles.detailValue}>{event.organizationId ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>identifier</td>
                <td className={styles.detailValue}>{event.identifier ?? '—'}</td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>createdAt</td>
                <td className={styles.detailValue}>
                  {event.createdAt ? new Date(event.createdAt).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'UTC', timeZoneName: 'short' }) : '—'}
                </td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>updatedAt</td>
                <td className={styles.detailValue}>
                  {event.updatedAt ? new Date(event.updatedAt).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'UTC', timeZoneName: 'short' }) : '—'}
                </td>
              </tr>
              <tr className={styles.detailRow}>
                <td className={styles.detailLabel}>id</td>
                <td className={styles.detailValue}>{event.id ?? '—'}</td>
              </tr>
            </tbody>
          </table>
          {event.baggage != null && (
            <div className={styles.detailSection}>
              <p className={styles.detailSectionTitle}>baggage</p>
              <pre className={styles.detailPre}>
                {JSON.stringify(event.baggage, null, 2)}
              </pre>
            </div>
          )}
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={onClose} size="small">Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AuditEventDetailDialog;
